import getMatchingVariant from '../utils/variants/getMatchingVariant';
import updatePrice from '../utils/variants/updatePrice';
import getSellingPlanPrice from '../utils/product/getSellingPlanPrice';
import updateWishlistButton from '../utils/product/updateWishlistBtn';
import updateSelectedVariant from '../utils/variants/updateSelectedVariants';
import updateFormControls from '../utils/variants/updateFormControls';
import updateURL from '../utils/variants/updateURL';
import preselectVariant from '../utils/variants/preselectVariant';
import updateVariantImages from '../utils/variants/updateVariantImages';
import updateProductGallery from '../utils/product/updateProductGallery';
import updateSaleBadge from '../utils/variants/updateSaleBadge';

const initProductVariants = (container = document.querySelector('[data-product-main]')) => {
  const variantEls = container.querySelectorAll('[data-variant-input]');
  const sellingPlanEls = container.querySelectorAll('[data-selling-plan-radio]');
  if (!variantEls.length && !sellingPlanEls.length) return;

  const form = container.querySelector('[data-product-form]');
  if (!form) return;

  const variantsDataEl = form.querySelector('[data-product-variants-json]');
  const optionNamesEl = form.querySelector('[data-product-options-json]');
  const variantInventoryEl = form.querySelector('[data-product-variants-inventory-policy-json]');
  const variantMaxQtyEl = form.querySelector('[data-product-variants-max-qty-json]');
  const variantStockEl = form.querySelector('[data-product-variants-stock-json]');
  const variantLeadTimeEl = form.querySelector('[data-product-variants-lead-time-json]');
  const variantIdInput = form.querySelector('[data-atc-id-input]');
  const sellingPlanGroupContainerEl = form.querySelector('[data-selling-plan-groups]');
  const sellingPlanIdInput = sellingPlanGroupContainerEl?.querySelector('[data-selling-plan-input]');
  const quantitySelector = form.querySelector('[data-quantity-selector]');
  const quantityInput = quantitySelector?.querySelector('[data-quantity-input]');
  const atcButton = form.querySelector('button[type="submit"]');
  const atcButtonMsg = atcButton?.querySelector('[data-atc-price-msg]');
  const productPreOrderMsg = container.querySelector('[data-product-preorder-msg]');
  const productSoldInfo = container.querySelector('[data-product-sold-info]');
  const productControls = container.querySelector('[data-product-controls]');
  const productStockCount = container.querySelector('[data-product-stock-count]');
  const productLeadTime = container.querySelector('[data-product-lead-time]');
  const productLeadTimeWrapper = container.querySelector('[data-product-lead-time-wrapper]');
  const klaviyoBIS = container.querySelector('[data-klaviyo-bis]');
  let wishlistButton = container.querySelector('[data-smart-wishlist-button]');

  let variantsData = [];
  let optionNames = [];
  let variantInventory = [];
  let variantMaxQuantities = [];
  let variantStock = [];
  let variantLeadTimes = [];

  try {
    variantsData = JSON.parse(variantsDataEl?.textContent || '[]');
    optionNames = JSON.parse(optionNamesEl?.textContent || '[]');
    variantInventory = JSON.parse(variantInventoryEl?.textContent || '[]');
    variantMaxQuantities = JSON.parse(variantMaxQtyEl?.textContent || '[]');
    variantStock = JSON.parse(variantStockEl?.textContent || '[]');
    variantLeadTimes = JSON.parse(variantLeadTimeEl?.textContent || '[]');
  } catch (e) {
    console.error('Invalid variant/options JSON', e);
    return;
  }

  const selectedOptions = {};
  const isPopup = document.querySelector('[data-atc-popup]')?.classList.contains('atc-popup-open') === true;
  const priceContainer = document.querySelector(
    isPopup ? '[data-product-price-popup]' : '[data-product-price-pdp]'
  );
  const priceEl = priceContainer?.querySelector('[data-product-price]');
  const compareAtPriceEl = priceContainer?.querySelector('[data-product-compare-at-price]');
  const saleBadgeEl = container.querySelector('[data-sale-badge]');
  const saleBadgePercentageEl = saleBadgeEl?.querySelector('[data-sale-badge-percentage]');

  const updateVariantDetails = () => {
    const variant = getMatchingVariant(selectedOptions, variantsData, optionNames);
    if (!variant) return;

    const price = getSellingPlanPrice(variant, sellingPlanIdInput?.value, 'price');
    const compareAtPrice = getSellingPlanPrice(variant, sellingPlanIdInput?.value, 'compare_at_price');

    variantIdInput && (variantIdInput.value = variant.id);
    // Lets other form features react to the variant (e.g. product-choices.js
    // swapping the colour choices to the selected variant's fabric range).
    form.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
    updatePrice({
      priceEl,
      compareAtPriceEl,
      price,
      compareAtPrice,
      badgeTemplate: window.theme.strings.priceBadgeText
    });

    updateSaleBadge({
      badgeEl: saleBadgeEl,
      percentageEl: saleBadgePercentageEl,
      price,
      compareAtPrice
    });

    updateSelectedVariant({
      variant,
      variantInventory,
      variantStock,
      variantLeadTimes,
      elements: {
        productPreOrderMsg,
        productSoldInfo,
        productControls,
        productStockCount,
        productLeadTime,
        productLeadTimeWrapper,
        klaviyoBIS,
        atcButtonMsg
      },
      form,
      strings: window.theme.strings
    });

    if (!isPopup) {
      updateURL({ variantID: variant.id, sellingPlanIdInput });
      wishlistButton = updateWishlistButton(wishlistButton, variant.id);
      if (!variant.available) {
        klaviyoBIS.dataset.unavailableVariantId = variant.id;
      }
    }

    updateFormControls({
      variant,
      qty: quantityInput ? +quantityInput.value : 1,
      variantsData,
      variantMaxQuantities,
      optionNames,
      selectedOptions,
      atcButton,
      quantitySelector,
      sellingPlanId: sellingPlanIdInput?.value,
      getSellingPlanPrice
    });

    updateProductGallery(variant);
    updateVariantImages(selectedOptions, variantsData, optionNames);
  };

  const updateSelectedOption = (name, value) => {
    selectedOptions[name] = value;
    updateVariantDetails();
  };

  if (variantEls.length) {
    variantEls.forEach(variant => {
      variant.addEventListener('change', ({ target }) => {
        const { name, value } = target;
        updateSelectedOption(name, value);
      });
    });
  }

  preselectVariant({
    variantsData,
    optionNames,
    form,
    selectedOptions,
    updateSelectedOption,
    updateVariantDetails,
    variantIdInput
  });
};

export default initProductVariants;
